import type { ProjectNote } from "@/lib/projectOverview";
import { splitNoteBodySegments } from "@/projectOverview/notes/noteReferences";
import type { NoteRefType } from "@/projectOverview/notes/types";

export function NoteMessageBody({
  note,
  onRefClick,
}: {
  note: ProjectNote;
  onRefClick: (type: NoteRefType | string, id: string, label: string) => void;
}) {
  const raw = String(note.note || "");
  const materialMirrored = raw.match(
    /^\[Material ([^\]]+)\]\s*\r?\n([\s\S]*)$/,
  );
  const mirrored = raw.match(
    /^Hinweis:\s*Diese Notiz wurde aus Auftrag\s+(#[^\s]+)\s+übernommen\.\s*\r?\n\r?\n([\s\S]*)$/,
  );

  if (materialMirrored) {
    const maLabel = materialMirrored[1];
    const message = materialMirrored[2] || "";
    return (
      <>
        <div className="eh-po-chat-system">
          Aus Materialanforderung {maLabel} (nur Büro)
        </div>
        {message ? <div className="mt-1 whitespace-pre-wrap">{message}</div> : null}
      </>
    );
  }

  if (mirrored) {
    const hint = `Hinweis: Diese Notiz wurde aus Auftrag ${mirrored[1]} übernommen.`;
    const message = mirrored[2] || "";
    return (
      <>
        <div className="eh-po-chat-system">{renderSegments(hint, note.references, onRefClick)}</div>
        {message ? (
          <div className="mt-1">{renderSegments(message, note.references, onRefClick)}</div>
        ) : null}
      </>
    );
  }

  return <>{renderSegments(raw, note.references, onRefClick)}</>;
}

function renderSegments(
  text: string,
  references: ProjectNote["references"],
  onRefClick: (type: NoteRefType | string, id: string, label: string) => void,
) {
  const segments = splitNoteBodySegments(text, references || []);
  return (
    <>
      {segments.map((seg, idx) => {
        if (seg.kind === "ref" && seg.ref) {
          return (
            <button
              key={`ref-${idx}-${seg.ref.start}`}
              type="button"
              className="eh-po-chat-ref"
              onClick={() =>
                onRefClick(seg.ref!.type, seg.ref!.ref_id, seg.ref!.label || seg.text)
              }
            >
              {seg.text}
            </button>
          );
        }
        return (
          <span key={`t-${idx}`} className="whitespace-pre-wrap">
            {seg.text}
          </span>
        );
      })}
    </>
  );
}
